import { c as _c } from "react/compiler-runtime";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import CreateWaveGroupSearchField from "./CreateWaveGroupSearchField";
import type { CreateWaveGroupSearchResultsLayout } from "./CreateWaveGroupSearchResults";
export default function CreateWaveInlineGroupSearch(t0) {
  const $ = _c(12);
  const {
    defaultLabel,
    disabled,
    hasUnsavedGroup,
    selectedGroup,
    allowGroupClear: t1,
    resultsLayout: t2,
    onSelect
  } = t0;
  const allowGroupClear = t1 === undefined ? true : t1;
  const resultsLayout = t2 === undefined ? "popover" : t2;
  let t3;
  if ($[0] !== hasUnsavedGroup) {
    t3 = hasUnsavedGroup && <div className="tw-rounded-lg tw-border tw-border-solid tw-border-primary-500/20 tw-bg-primary-500/5 tw-p-3"><p className="tw-mb-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-primary-300">Unsaved group</p><p className="tw-mb-0 tw-text-xs tw-font-medium tw-text-iron-300">Choosing another group will discard this unsaved group.</p></div>;
    $[0] = hasUnsavedGroup;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== allowGroupClear || $[3] !== defaultLabel || $[4] !== disabled || $[5] !== onSelect || $[6] !== resultsLayout || $[7] !== selectedGroup) {
    t4 = <CreateWaveGroupSearchField label={"Search groups\u2026"} defaultLabel={defaultLabel} disabled={disabled} selectedGroup={selectedGroup} allowClear={allowGroupClear} resultsLayout={resultsLayout} onSelect={onSelect} />;
    $[2] = allowGroupClear;
    $[3] = defaultLabel;
    $[4] = disabled;
    $[5] = onSelect;
    $[6] = resultsLayout;
    $[7] = selectedGroup;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="tw-space-y-3">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}